import { render, staticRenderFns } from "./AppCnpjField.vue?vue&type=template&id=41c63e4d&"
import script from "./AppCnpjField.vue?vue&type=script&lang=js&"
export * from "./AppCnpjField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports